import type { TaskStatus } from '../../services/api/types.gen';

/**
 * Payroll's one set of visit-status labels: the Admin tab's Payroll settings,
 * the line under the Unpaid heading and the Unpaid table's Status column all
 * read it, so a status is never called two things on the way from the setting
 * to the row.
 *
 * Payroll's own wording, matching Kinnser ("Submitted w/ Signature"), not the
 * chart's "Submitted (Signed)" in `task/taskStatus.ts`. The Excel export reads
 * the backend's `STATUS_LABELS` in `services/payroll_export.py`, which carries
 * the same words; a backend test reads this map and fails if the two differ.
 */
export const PAYROLL_STATUS_LABELS: Partial<Record<TaskStatus, string>> = {
  saved: 'Saved',
  returned_for_review: 'Returned for Review',
  reopened: 'Reopened',
  submitted: 'Submitted',
  pending_clinician_signature: 'Pending Clinician Signature',
  submitted_with_signature: 'Submitted w/ Signature',
  completed: 'Completed',
  exported: 'Exported',
};

/** The payroll label for a status, or a readable form of one payroll never offers. */
export function payrollStatusLabel(status: TaskStatus): string {
  return (
    PAYROLL_STATUS_LABELS[status] ??
    status
      .split('_')
      .map(part => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ')
  );
}
